import { useParams } from 'react-router-dom';
import ButtonIcon from 'components/ButtonIcon';
import Trash from 'components/icons/trash';
import Pencil from 'components/icons/pencil3';
import Phone from 'components/icons/phone';
import SmsIcon from 'components/icons/sms';
import PromoteIcon from 'components/icons/promote';
import { Phonenumber } from 'data/firestore/agent/customer/phonenumber/types';
import useManageCustomerFallbackNumbers from 'data/hooks/useManageCustomerFallbackNumbers';
import useSMSChat from 'hooks/useSMSChat';
import { ActionsCellWrapper } from './styled';

interface Props {
    row?: Phonenumber;
    disabled?: boolean;
}

const ActionsColumn = ({
    row = {} as Phonenumber,
    disabled = false,
}: Props) => {
    const { agentId = '', customerId = '' } = useParams();
    const { openChat } = useSMSChat();
    const {
        edit, remove, callPhone, promote,
    } = useManageCustomerFallbackNumbers({ agentId, customerId });

    return (
        <ActionsCellWrapper>
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Phone />}
                tooltip="Call phone number"
                size="small"
                disabled={disabled || !row?.phoneNumber}
                onClick={() => callPhone(row)}
            />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<SmsIcon />}
                tooltip="Send sms"
                size="small"
                disabled={disabled || !row?.phoneNumber}
                onClick={() => openChat({ id: customerId, phoneNumber: row?.phoneNumber })}
            />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Pencil />}
                tooltip="Edit phone number"
                size="small"
                disabled={disabled}
                onClick={() => edit(row as unknown as Phonenumber)}
            />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<PromoteIcon />}
                tooltip="Set as primary phone number"
                size="small"
                disabled={disabled || row?.type === 'primary' || !row?.phoneNumber}
                onClick={() => promote(row?.id)}
            />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Trash />}
                tooltip="Remove phone number"
                size="small"
                disabled={disabled || row?.type === 'primary'}
                onClick={() => remove(row?.id)}
            />
        </ActionsCellWrapper>
    );
};

export default ActionsColumn;
